<div class="card">
  <header class="card-header">
    <p class="card-header-title is-size-4 has-background-white-ter">{{ 'claimMetadata.title' | localize }}&nbsp;-&nbsp;
      <span class="is-6">{{ 'menu.createClaim.forSingleBuilding.label' | localize }}</span></p>
  </header>
  <div class="card-content">
    <article class="content">
      <span class="is-size-6 pl-3">{{ 'claimMetadata.instruction' | localize }}</span>
    </article>

    <div class="container">
      <form [formGroup]="metadataForm" class="metadata-form">
        <div class="columns is-gapless-mobile">
          <div class="column is-6">
            <mat-form-field appearance="outline" class="field-spacing">
              <mat-label>{{ 'claimMetadata.policyNumber.label' | localize }}</mat-label>
              <input matInput formControlName="claimNumber"
                     placeholder="{{ 'claimMetadata.policyNumber.label' | localize }}">
            </mat-form-field>
          </div>
          <div class="column is-6">
            <mat-form-field appearance="outline" class="field-spacing">
              <mat-label>{{ 'claimMetadata.unitOwnerName.label' | localize }}</mat-label>
              <input matInput formControlName="unitOwnerName" placeholder="{{ 'claimMetadata.unitOwnerName.placeholder' | localize }}">
            </mat-form-field>
          </div>
        </div>

        <div class="columns is-gapless-mobile">
          <div class="column is-6">
            <div class="columns is-full">
              <div class="column is-full">
                <mat-form-field appearance="outline" class="field-spacing">
                  <mat-label>{{ 'claimMetadata.policyLimit.label' | localize }}</mat-label>
                  <input type="number" min="0" matInput formControlName="policyLimit"
                         placeholder="{{ 'claimMetadata.policyLimit.label' | localize }}">
                </mat-form-field>
                <mat-form-field appearance="outline" class="field-spacing">
                  <mat-label>{{ 'claimMetadata.claimType.label' | localize }}</mat-label>
                  <mat-select formControlName="claimType">
                    @for (ctype of claimTypes; track ctype) {
                      <mat-option [value]="ctype">{{ ctype | localize }}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          </div>
          <div class="column is-6">
            <mat-form-field appearance="outline" class="field-spacing">
              <mat-label>{{ 'claimMetadata.address.label' | localize }}</mat-label>
              <textarea matInput formControlName="address" rows="5" placeholder="{{ 'claimMetadata.address.placeholder' | localize }}"></textarea>
            </mat-form-field>
          </div>
        </div>
      </form>
    </div>

    @if (error && !isSubmitting) {
      <div class="message is-danger">
        <div class="message-body">
          {{ error }}
        </div>
      </div>
    }
  </div>
  <footer class="card-footer">
    <div class="card-footer-item">
      @if (isSubmitting) {
        <mat-spinner></mat-spinner>
      } @else {
        <button [disabled]="isSubmitting" class="button is-dark" (click)="onInitiateClaim()">{{ 'claimMetadata.initiateClaim' | localize }}</button>
      }
    </div>
  </footer>
</div>
